import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2220297e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "my-2 text-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "question-title my-1" }, "✍", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "question-title my-1" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = { class: "my-3" }
const _hoisted_8 = { class: "my-2" }
const _hoisted_9 = { class: "my-2" }
const _hoisted_10 = { class: "italic" }
const _hoisted_11 = { class: "row align-items-center" }
const _hoisted_12 = { class: "col-12 col-lg-auto mx-2 my-2 text-center" }
const _hoisted_13 = {
  key: 0,
  class: "my-2"
}
const _hoisted_14 = { class: "nameplate" }
const _hoisted_15 = { class: "my-2" }
const _hoisted_16 = ["src"]
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "col-12 col-lg mx-2 my-2" }
const _hoisted_19 = { class: "my-3" }
const _hoisted_20 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LevelBadge = _resolveComponent("LevelBadge")!
  const _component_Message = _resolveComponent("Message")!
  const _component_InputMessage = _resolveComponent("InputMessage")!
  const _component_Tile = _resolveComponent("Tile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.question.word.word), 1),
      _hoisted_6,
      _createVNode(_component_LevelBadge, {
        class: "my-1",
        icon: "✍",
        score: _ctx.question.word.writingScore,
        level: _ctx.question.word.writingLevel,
        progress: _ctx.question.word.writingProgress
      }, null, 8, ["score", "level", "progress"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('practice.fillBlank', {word: _ctx.question.word.word})), 1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_Tile, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.answer.example.scenario), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.answer.example.dialogue, (dialogue, idx) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                (dialogue.name)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("span", _hoisted_14, _toDisplayString(dialogue.name), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_15, [
                  (dialogue.portrait)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "portrait",
                        src: require(`@/assets/portraits/${dialogue.portrait}.png`)
                      }, null, 8, _hoisted_16))
                    : (_openBlock(), _createElementBlock("img", {
                        key: 1,
                        class: "portrait",
                        src: require('@/assets/portraits/s_1.png')
                      }, null, 8, _hoisted_17))
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                (idx !== _ctx.answer.missingIndex)
                  ? (_openBlock(), _createBlock(_component_Message, {
                      key: 0,
                      type: dialogue.type,
                      text: dialogue.text,
                      translation: dialogue.translation
                    }, null, 8, ["type", "text", "translation"]))
                  : (_openBlock(), _createBlock(_component_InputMessage, {
                      key: 1,
                      type: dialogue.type,
                      text: dialogue.text,
                      onUpdateText: ($event: any) => (_ctx.answer.example.dialogue[idx].text = $event),
                      translation: dialogue.translation,
                      onUpdateTranslation: ($event: any) => (_ctx.answer.example.dialogue[idx].translation = $event)
                    }, null, 8, ["type", "text", "onUpdateText", "translation", "onUpdateTranslation"]))
              ])
            ]))
          }), 256))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('answer', _ctx.answer)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("button", {
          type: "submit",
          class: "btn btn-secondary",
          disabled: _ctx.answerLoading || _ctx.answered
        }, _toDisplayString(_ctx.$t('practice.answerButton')), 9, _hoisted_20)
      ])
    ], 32)
  ]))
}